import React from 'react'

export const HighlightRenderer = ({ children }: { children: any }) => {
  return <span className="px-2 / text-primary bg-tetriary">{children}</span>
}
